const ROUTES = {
  LOGIN: '/',
  DASHBOARD: '/dashboard',
  OVERVIEW: '/dashboard/overview',
  ONLINE_REVIEW: '/dashboard/online-reviews',
  FEEDBACK: '/dashboard/feedback',
  AI_INSIGHTS: '/dashboard/ai-insights',
  INVALID: '/404',
  DEFAULT: '*'
};

export default ROUTES;
